import React from 'react'
import tachyon from '../utils/tachyon'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import AriaTooltips from './AriaTooltips';

const eventHasButton = (hit) => {
    if (hit.attendable.hasBookingButton === true) {
        return <a className={"c-btn c-btn--red c-btn--ghost c-btn--small " + (hit.attendable.bookingLabel === 'Sold Out' ? 'c-btn--soldout' : '')} href={hit.attendable.bookingUrl}><i className="far fa-ticket-alt"></i> {hit.attendable.bookingLabel}</a>;
    }
    return '';
}

/*eslint jsx-a11y/anchor-has-content: 0 */
const Event = ({ hit }) => (
    <section className="c-event-card fadeInUp">
        <a className="c-event-card__link" href={hit.permalink}>
            <figure className="c-event-card__img">
                <LazyLoadImage src={tachyon.fetch(hit.cover_url, { resize: '600,400', gravity: 'center' })} alt={hit.post_title}
                    placeholderSrc={tachyon.fetch(hit.cover_url, { resize: '60,40', gravity: 'center' })} />
            </figure>
        </a>
        <div className="c-event-card__body">
            <h3 className="c-event-card__title">{hit.post_title}</h3>
            <div className="c-event-card__details">
                <time className="c-event-card__date"><i className="far fa-calendar"></i> {hit.attendable.listingDateLabel}</time>
                <div className="c-event-card__venues">
                    <div className="c-event-card__meta c-event-card__venue">
                        {hit.attendable.venues.map(venue => <span key={venue}><i className="fal fa-map-marker-alt"></i> {venue}</span>)}
                    </div>
                </div>
            </div>
            <div className="c-event-card__description c-col-txt-area">{hit.excerpt || ''}</div>

            <div className="c-event-card__bottom-details">


                {hit.attendable.seasons && hit.attendable.seasons.map(season => <div className="c-event-card__season"><a key={season.title} className="c-link" href={season.permalink}>{season.title}</a></div>)}


                <div className="c-access-labels">
                    <AriaTooltips access={hit.attendable.access || []} />
                </div>
            </div>
            <div className="c-event-card__actions">

                {eventHasButton(hit)}

                <a className="c-btn c-btn--red c-btn--small" href={hit.permalink}><i className="far fa-arrow-right"></i> Discover more</a>
            </div>

            <a className="c-event-card__cover-link" href={hit.permalink}></a>

        </div>
    </section>
);


export default Event;



// WEBPACK FOOTER //
// ./src/whatson/components/Event.js